import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "card p-3 mb-4" }
const _hoisted_2 = { class: "row g-2 align-items-end" }
const _hoisted_3 = { class: "col-lg-4 col-md-4 col-sm-6" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { value: "" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-lg-4 col-md-4 col-sm-6" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          class: "form-control form-control-sm form-control-solid",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.roleId) = $event)),
          placeholder: _ctx.translate('roles')
        }, [
          _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.translate('selectRole')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRoles, (role) => {
            return (_openBlock(), _createElementBlock("option", {
              key: role.id,
              value: role.id
            }, _toDisplayString(role.name), 9, _hoisted_6))
          }), 128))
        ], 8, _hoisted_4), [
          [_vModelSelect, _ctx.selectedItems.roleId]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "email",
          class: "form-control form-control-sm form-control-solid",
          placeholder: _ctx.translate('email'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.email) = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
        }, null, 40, _hoisted_8), [
          [_vModelText, _ctx.selectedItems.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light me-1",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, _toDisplayString(_ctx.translate('reset')), 1),
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _toDisplayString(_ctx.translate('apply')), 1)
      ])
    ])
  ]))
}